<style scoped lang="less">
</style>
<template>
	<div>
		<titles titlename="实训档案管理详情" titlecontent="这里可以看到档案详情" :mbx="paths"></titles>
		
	</div>
</template>

<script>
	import titles from "@/components/title/title.vue"
	
	export default{
		data(){
			return{
				// 标题
				paths: [{
					path: "/usercenter/myuserpromise",
					name: "实训档案详情"
				}],
			}
		},
		components: {
			titles
		}
		
	}
	
	
</script>

